import { toast } from "react-toastify";
import baseApi from "../../../API/baseApi";
import routes from "../../../API/routes";

export async function listarRelacoesPrevidenciarias(filtros) {
    try {
        const response = await baseApi.get(`${routes.relacoesPrevidenciarias.listarRelacoes}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao recuperar as relações previdenciárias.');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao recuperar as relações previdenciárias.');
        return null;
    }
}

export async function atualizarRelacaoPrevidenciaria(dados) {     
    try {
        const response = await baseApi.put(`${routes.relacoesPrevidenciarias.atualizarRelacao}`, dados);

        if(response.data.success){
            toast.success(response.data.message || 'Relação previdenciária alterada com sucesso.');
            return { sucesso: true };
        }else{
            toast.error(response.data.message || 'Ocorreu um erro ao alterar a relação previdenciária.');
            return { sucesso: false };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao alterar a relação previdenciária.');
        return { sucesso: false };
    } 
}

export async function buscarRelacaoCnisFontesPagadoras(filtros) {
    try {
        const response = await baseApi.get(`${routes.relacoesPrevidenciarias.listarCnisFontes}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao recuperar a relação CNIS x Fontes Pagadoras.');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao recuperar a relação CNIS x Fontes Pagadoras.');
        return null;
    }
}

export async function atualizarRelacaoCnisFontesPagadoras(dados) {     
    try {
        const response = await baseApi.put(`${routes.relacoesPrevidenciarias.atualizarCnisFontes}`, dados);

        if(response.data.success){
            toast.success(response.data.message || 'Confirmação realizada com sucesso');
            return { sucesso: true };
        }else{
            toast.error(response.data.message || 'Ocorreu um erro ao confirmar');
            return { sucesso: false };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao confirmar');
        return { sucesso: false };
    } 
}

export async function buscarRemuneracoesRetencoes(filtros) {
    try {
        const response = await baseApi.get(`${routes.relacoesPrevidenciarias.listarRemuneracoes}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao recuperar as remunerações e retenções.');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao recuperar as remunerações e retenções.');
        return null;
    }
}
